import whenDomReady from "when-dom-ready";
import renderFromPreloadedJSON from "~/common/renderFromPreloadedJSON";
import FoodServiceResourcesArticle from "./FoodServiceResourcesBuyingGuide";

whenDomReady(() => {
  renderFromPreloadedJSON(
    FoodServiceResourcesArticle,
    "FoodServiceResourcesBuyingGuide",
  );
});
